import { Box, IconButton, Stack, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import Iconify from '../iconify';
import { catalogs } from '../../utils/catalogs';
import { getQuestionaryAnalyticsData, onGetCurrentPeriod, onGetFirstTimeAndFollowUpPatients } from '../../pages/Businesses/BusinessProgramPage/analytics_utils';
import QuestionarySymptomChart from './anexo/QuestionarySymptomChart';

const AnexoReport = ({
    period,
    appointments,
    program_users,
    onReturn
}) => {

    const [valid_appointments, setValidAppointments] = useState([])
    const [digestion_data, setDigestionData] = useState({
            follow_up:null,
            first_time:null
    })
    const [physical_codition_data, setPhysicalConditionData] = useState({
        follow_up:null,
        first_time:null
    })
    const [sleep_quality_data, setSleepQualityData] = useState({
        follow_up:null,
        first_time:null
    })
    const [energy_level_data, setEnergyLevelData] = useState({
        follow_up:null,
        first_time:null
    })

    const onGetValidDiagnostic = useCallback((data, options=[]) => {
        let result = null
        try {
            const value = JSON.parse(data)
            result = options.find(el => value.points > el.min && value.points <= el.max)
        } catch (error) {
            console.log(error)
        }
        return result
    },[])

    useEffect(() => {
        //console.log("Appointments", appointments.length)
        //console.log(appointments)
        let _filterappointments = []
        for (let index = 0; index < appointments.length; index++) {
            let appointment = appointments[index];
            const {digestion_status_answers, physical_condition_answers, sleep_quality_answers, energy_level_answers} = appointment
            if(digestion_status_answers && physical_condition_answers && sleep_quality_answers && energy_level_answers ){
                //console.log(JSON.parse(digestion_status_answers))
                const digestion = onGetValidDiagnostic(digestion_status_answers, catalogs.digestion_statuses)
                if(digestion) appointment.digestion_status_id = digestion.value
                const physical_condition = onGetValidDiagnostic(physical_condition_answers, catalogs.physical_conditions)
                if(physical_condition) appointment.physical_condition_id = physical_condition.value
                const sleep_quatity = onGetValidDiagnostic(sleep_quality_answers, catalogs.sleep_qualities)
                if(sleep_quatity) appointment.sleep_quality_id = sleep_quatity.value
                const energy_level = onGetValidDiagnostic(energy_level_answers, catalogs.energy_levels)
                if(energy_level) appointment.energy_level_id = energy_level.value
                _filterappointments.push(appointment)
            }
        }
        //console.log("Clean Appointments", _filterappointments.length)
        setValidAppointments(_filterappointments)
    },[appointments])

    const onGetDigestionAnalyticData = useCallback((first_users, follow_users) => {
        
        let result_first = getQuestionaryAnalyticsData(first_users, 'digestion_status_id', catalogs.digestion_statuses)
        let result_follow = getQuestionaryAnalyticsData(follow_users, 'digestion_status_id', catalogs.digestion_statuses)
        setDigestionData({
            first_time:result_first,
            follow_up:result_follow
        })

    },[valid_appointments])

    const onGetPhysicalConditionAnalyticData = useCallback((first_users, follow_users) => {
        
        let result_first = getQuestionaryAnalyticsData(first_users, 'physical_condition_id', catalogs.physical_conditions)
        let result_follow = getQuestionaryAnalyticsData(follow_users, 'physical_condition_id', catalogs.physical_conditions)
        setPhysicalConditionData({
            first_time:result_first,
            follow_up:result_follow
        })

    },[valid_appointments])

    const onGetSleepQualityAnalyticData = useCallback((first_users, follow_users) => {
        
        let result_first = getQuestionaryAnalyticsData(first_users, 'sleep_quality_id', catalogs.sleep_qualities)
        let result_follow = getQuestionaryAnalyticsData(follow_users, 'sleep_quality_id', catalogs.sleep_qualities)
        setSleepQualityData({
            first_time:result_first,
            follow_up:result_follow
        })

    },[valid_appointments])

    const onGetEnergyLevelAnalyticData = useCallback((first_users, follow_users) => {
        
        let result_first = getQuestionaryAnalyticsData(first_users, 'energy_level_id', catalogs.energy_levels)
        let result_follow = getQuestionaryAnalyticsData(follow_users, 'energy_level_id', catalogs.energy_levels)
        setEnergyLevelData({
            first_time:result_first,
            follow_up:result_follow
        })

    },[valid_appointments])

    useEffect(() => {
        const validPeriod = onGetCurrentPeriod(period)
        const {follow_up_users, first_time_users} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)
        onGetDigestionAnalyticData(first_time_users, follow_up_users)
        onGetPhysicalConditionAnalyticData(first_time_users, follow_up_users)
        onGetSleepQualityAnalyticData(first_time_users, follow_up_users)
        onGetEnergyLevelAnalyticData(first_time_users, follow_up_users)
    },[valid_appointments, period])

    return ( 
        <Box>
            <Stack direction='row' sx={{mb:3}}>
                <IconButton onClick={onReturn}>
                    <Iconify icon="material-symbols:arrow-back-rounded" />
                </IconButton>
                <Typography variant='h5'>
                    Sintomatología
                </Typography>
                
            </Stack>
            <Box>
                <Stack spacing={3}>
                    <QuestionarySymptomChart 
                        title={"Clasifición por digestión"}
                        first_time_data={digestion_data.first_time}
                        follow_up_data={digestion_data.follow_up}
                    />
                    <QuestionarySymptomChart 
                        title={"Clasifición por condición física"}
                        first_time_data={physical_codition_data.first_time}
                        follow_up_data={physical_codition_data.follow_up}
                    />
                    <QuestionarySymptomChart 
                        title={"Clasifición por calidad de sueño"}
                        first_time_data={sleep_quality_data.first_time}
                        follow_up_data={sleep_quality_data.follow_up}
                    />
                    <QuestionarySymptomChart 
                        title={"Clasifición por nivel de energía"}
                        first_time_data={energy_level_data.first_time}
                        follow_up_data={energy_level_data.follow_up}
                    />
                    {/*<AnnexByObjectiveReport 
                        idclient={idclient}
                        idclientprogram={idclientprogram}
                        period={period}
                    */}
                </Stack>
                
            </Box>
        </Box>
     );
}
 
export default AnexoReport;